import React from "react"
import styled from "styled-components"
import { Helmet } from "react-helmet"
import Drawers from "../../UI/Drawers"

interface IProps {
  title: string
  questions: {
    title: string
    answer: string
  }[]
}

const Wrapper = styled.div`
  max-width: 700px;
  margin: 30px auto 30px auto;
  padding: 0px 20px;
  position: relative;
  z-index: 1;
`

const FAQSection = (props: IProps) => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: props.questions.map(q => ({
      "@type": "Question",
      name: q.title,
      acceptedAnswer: {
        "@type": "Answer",
        text: q.answer,
      },
    })),
  }

  return (
    <Wrapper>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <Drawers
        title={props.title}
        questions={props.questions.map(q => ({
          title: q.title,
          answer: q.answer,
        }))}
      />
    </Wrapper>
  )
}

export default FAQSection
